import {
  Component, Input, Output, EventEmitter, OnInit, OnDestroy,
  AfterViewInit, ViewChild, ViewContainerRef, inject, OnChanges, SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { WizardService, WizardDefaultsDto } from '../../core/services/wizard.service';

// ⚠️ Respecte bien la casse des dossiers : V1 / V2
import { WizardModalComponent as WizardV1 } from './V1/wizard-modal.component';
import { WizardModalComponent as WizardV2 } from './V2/wizard-modal.component';

@Component({
  selector: 'app-wizard-modal',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <!-- Hôte toujours présent dans le DOM -->
    <ng-template #host></ng-template>

    <!-- Overlay de chargement indépendant -->
    <div *ngIf="!loaded" class="modal-backdrop" aria-modal="true" role="dialog">
      <div class="modal" tabindex="-1">
        <div class="loading">Chargement…</div>
      </div>
    </div>
  `,
})
export class WizardModalHostComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @Input({ required: true }) establishmentId!: string;
  @Output() close = new EventEmitter<void>();
  @Output() completed = new EventEmitter<void>();

  @ViewChild('host', { read: ViewContainerRef }) hostVc?: ViewContainerRef;

  private api = inject(WizardService);

  defaults?: WizardDefaultsDto;
  loaded = false;

  ngOnInit(): void {
    document.body.classList.add('modal-open');
    this.fetchDefaults();
  }

  ngOnDestroy(): void {
    document.body.classList.remove('modal-open');
  }

  ngAfterViewInit(): void {
    this.maybeRender();
  }

  // 🔁 recharger si l’établissement change
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['establishmentId'] && !changes['establishmentId'].firstChange) {
      this.fetchDefaults();
    }
  }

  private fetchDefaults(): void {
    this.loaded = false;
    this.defaults = undefined;

    this.api.getDefaults(this.establishmentId).subscribe({
      next: (d) => {
        this.defaults = d;
        this.loaded = true;
        this.maybeRender();
      },
      error: () => {
        this.defaults = {
          wizardId: 'establishment-setup',
          version: null,
          label: null,
          payloadDefault: {},
        };
        this.loaded = true;
        this.maybeRender();
      },
    });
  }

  /** Rend la bonne version quand #host et defaults sont prêts */
  private maybeRender(): void {
    if (!this.hostVc || !this.defaults) return;

    const ver = this.defaults?.version ?? 1;
    const component: any = ver >= 2 ? WizardV2 : WizardV1;

    this.hostVc.clear();
    const ref = this.hostVc.createComponent<any>(component as any);

    // Inputs
    (ref.instance as any).establishmentId = this.establishmentId;
    (ref.instance as any).defaults = this.defaults;

    // Outputs -> relais vers le parent
    (ref.instance as any).close?.subscribe?.(() => this.close.emit());
    (ref.instance as any).completed?.subscribe?.(() => this.completed.emit());
  }
}
